interface RapidFireToggleProps {
  on: boolean;
  onToggle: () => void;
}

/**
 * The rapid-fire overlay toggle (SC2-only, shown once a Profile is loaded). A labelled pill in the
 * top bar - the live-wire icon plus "Rapid-fire" text - so the control is discoverable. The
 * icon stays ember even when off; the whole pill fills ember when the marks are showing, mirroring
 * the Compare toggle's on/off affordance. Moved here from the retired settings panel.
 */
export function RapidFireToggle({ on, onToggle }: RapidFireToggleProps) {
  return (
    <button
      type="button"
      className={on ? "rf-pill on" : "rf-pill"}
      onClick={onToggle}
      aria-pressed={on}
      title={on ? "Hide rapid-fire keys" : "Show rapid-fire keys"}
      aria-label={on ? "Hide rapid-fire keys" : "Show rapid-fire keys"}
    >
      <svg
        className="rf-ico"
        aria-hidden="true"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
      </svg>
      Rapid-fire
    </button>
  );
}
